"use client";

interface JobCardSkeletonProps {
  count?: number;
}

export default function JobCardSkeleton({ count = 1 }: JobCardSkeletonProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="bg-white rounded-2xl border border-gray-100 h-full flex flex-col animate-pulse"
        >
          <div className="p-6 flex flex-col flex-1">
            {/* Department Badge Skeleton */}
            <div className="mb-5">
              <div className="h-7 w-28 bg-gray-100 rounded-full" />
            </div>

            {/* Title Skeleton */}
            <div className="h-7 w-4/5 bg-gray-100 rounded-lg mb-4" />

            {/* Meta Info Skeleton */}
            <div className="space-y-3 mb-6 flex-1">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-gray-100 rounded-lg" />
                <div className="h-4 w-24 bg-gray-100 rounded" />
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-gray-100 rounded-lg" />
                <div className="h-4 w-20 bg-gray-100 rounded" />
              </div>
            </div>

            {/* CTA Skeleton */}
            <div className="flex items-center justify-between pt-4 border-t border-gray-100">
              <div className="h-4 w-24 bg-gray-100 rounded" />
              <div className="w-10 h-10 bg-gray-100 rounded-full" />
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
